module.exports = __webpack_public_path__ + "img/icon_data0.72567ad7.svg";